import { REQUIRED_COMPANY_PROFILE_FIELDS } from '../constants/accountSetup.constants';

export const hasRequiredCompanyProfile = (values) =>
  REQUIRED_COMPANY_PROFILE_FIELDS.every((field) => Boolean(values?.[field]?.trim()));

export const isCompanyProfileFieldRequired = (field) =>
  REQUIRED_COMPANY_PROFILE_FIELDS.includes(field);
